import { useMemo } from 'react';
import type { Fixture } from '@h2h/shared';
import {
  enrichCyclingFixtures,
  mergeRiderMetaMaps,
  riderMetaFromFixtures,
  riderMetaFromStandings
} from '../../lib/cyclingRiderMeta';
import { useCyclingStandings } from './leaguePlay';

/**
 * Best-effort rider team/nationality for cycling pick UI — merges whatever is on
 * the duel fixtures with the league's race standings doc when refs are bare.
 */
export function useEnrichedCyclingFixtures(leagueId: string | undefined, fixtures: Fixture[] | undefined) {
  const { data: standings } = useCyclingStandings(leagueId);
  const meta = useMemo(
    () => mergeRiderMetaMaps(riderMetaFromStandings(standings), riderMetaFromFixtures(fixtures)),
    [standings, fixtures]
  );
  const enriched = useMemo(
    () => (fixtures?.length ? enrichCyclingFixtures(fixtures, meta) : fixtures),
    [fixtures, meta]
  );
  return enriched;
}
